module.exports = __webpack_public_path__ + "static/media/banner_9.e6b0d678.jpg";